import styled from 'styled-components';
export const RouteImageStyled = styled.figure `
  position: relative;
  width: 208px;
  height: 288px;
  border-radius: 4px;
  transition: box-shadow 0.3s ease;
  display: flex;
  flex-direction: column-reverse;

  &:hover {
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }
`;
export const RouteLink = styled.a `
  text-decoration: none;
  color: unset;

  &:visited {
    text-decoration: none;
    color: unset;
  }
`;
export const RouteImg = styled.img `
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;
export const RouteImageDescription = styled.span `
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
  font-size: ${({ theme }) => theme.fontSizesV2.titleBody18.lg};
  font-weight: 600;
  line-height: 24px;
`;
export const RouteImageDescriptionWrapper = styled.figcaption `
  backdrop-filter: blur(12px);
  padding: 8px 8px 8px 16px;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
export const RouteImageLinkText = styled.span `
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-size: ${({ theme }) => theme.fontSizesV2.titleBody14.lg};
  line-height: 32px;
  font-weight: 600;
`;
//# sourceMappingURL=RouteImage.styled.js.map